import { fetchData } from 'store/pages/performer/actions/fetchData'
import { fetchEvents } from 'store/pages/performer/actions/fetchEvents'
import { fetchMetadata } from 'store/pages/performer/actions/fetchMetadata'
import { fetchSeasons } from 'store/pages/performer/actions/fetchSeasons'

import { getData } from './getData'
import { getBulkData } from './getBulkData'

import { PerformerSlice } from '../slice'
import { getActiveEvents } from './getActiveEvents'
import { getActiveTypeticketcollections } from './getActiveTypeticketcollections'

export const PerformerActions = {
  ...PerformerSlice.actions,
  fetchData,
  fetchEvents,
  fetchSeasons,
  fetchMetadata,
  getData,
  getBulkData,
  getActiveEvents,
  getActiveTypeticketcollections
}
